module.exports = __webpack_public_path__ + "6649e2e4059f9c40309001309e607f2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-yubisasi.png
// module id = 2075
// module chunks = 4